import './SelectionBlock.css';
import React from 'react';
import {useRef, useState, useEffect} from 'react';

function SelectionBlock(props) {

  const selectionBlockRef = useRef();

  const [selectionSticky, setSelectionSticky] = useState(false);

  var scrollTopPosition = window.document.scrollTop;

  /**
   * Инициализация события при скролле для фиксации блока выбора на мобильной версии
   */
  useEffect(() => {
    window.addEventListener('scroll', ev => (onScroll(ev)));
    return () => {
      window.removeEventListener('scroll', ev => (onScroll(ev)));
    };
  }, []);

  /**
   *
   * @param {Event} event
   */
  function onScroll(event) {
    //console.info(event);
    /**
     * @var {HTMLElement|null} selectionBlockRef.current
     */
    if (!(selectionBlockRef.current instanceof HTMLElement)) return;

    let positionTop = selectionBlockRef.current.getBoundingClientRect().top,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    let scrollDiff = props.clientWidth < 1279 && props.clientWidth > 1023 ? 50 :
        props.clientWidth < 1024 ? 70 : 0;

    /*console.info(scrollTop > (positionTop + scrollTop - scrollDiff));
    console.info(scrollTop > scrollTopPosition);*/

    if (scrollTop > (positionTop + scrollTop - scrollDiff)) {
      setSelectionSticky(scrollTop < scrollTopPosition);
    }

    //console.info(scrollTopPosition, positionTop, scrollTop, scrollDiff);

    scrollTopPosition = scrollTop;
  }

  return (
      <section id={'selection-block'}
               className={`${selectionSticky ? 'sticky' : ''}`}
               ref={selectionBlockRef}>{props.children}</section>
  );
}

export default SelectionBlock;